export default __webpack_public_path__ + "static/media/Certificate_1.60d46f79.jpg";